import { useConnectionCatalog } from './useConnectionCatalog';
import { useConnections } from './useConnections';

/**
 * How many connections the Connections tab counts (spec 229 FR-005, research
 * R5): those whose type the catalogue lists, single- and multi-instance alike —
 * the rule the page's header used to apply. `undefined` while either read is
 * pending or has failed, so the strip draws no count rather than a wrong one.
 */
export function useConnectedCount(
  workspaceId: string,
  { enabled = true }: { enabled?: boolean } = {},
): number | undefined {
  const { connections } = useConnections(workspaceId, { enabled });
  const catalog = useConnectionCatalog(workspaceId, { enabled });
  if (!enabled || !connections || catalog.providers === undefined) {
    return undefined;
  }
  const listed = new Set(
    [...catalog.providers, ...(catalog.multiProviders ?? [])].map(
      (provider) => provider.type,
    ),
  );
  return connections.filter((connection) => listed.has(connection.type)).length;
}
